import React from "react";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { Formik } from "formik";
import { Box, Button, Container, TextField, Typography, makeStyles } from "@material-ui/core";
import { Alert, AlertTitle } from "@material-ui/lab";
import Page from "src/components/Page";
import LoginImage from "../../icons/login.png";
import Loader from "react-loader-spinner";
import { AuthService } from "../../services/";
import { useDispatch } from "react-redux";
import { login } from "../../redux/actions/auth";
import TopBar from "../../layouts/DashboardLayout/TopBar";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    height: "100%",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
}));

const LoginView = (props) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {t} = useTranslation();
  const [isMobileNavOpen, setMobileNavOpen] = React.useState(false);

  return (
    <Page className={classes.root} title="Login">
      <TopBar onMobileNavOpen={() => setMobileNavOpen(true)} />
      <Box display="flex" flexDirection="column" height="100%" justifyContent="center" >
        <Container maxWidth="sm">
          <Formik
            initialValues={ {
              email: "adminhasan@a.com",
              password: "Abc123!!",
            }}
            validationSchema={Yup.object().shape({
              email: Yup.string()
                .email("Must be a valid email")
                .max(255)
                .required("Email is required"),
              password: Yup.string().max(255).required("Password is required"),
            })}
            onSubmit={(values,{setSubmitting,setStatus}) => {
              // Call get_Token Api
              AuthService.LOGIN_USER(values.email, values.password)
                .then(({data}) =>{  
                  const{userName,access_token,role,party_id,language_code} = data.data; 
                  // global user-token güncelleme yap 
                  dispatch(login(access_token,userName,role,party_id,language_code));
                  navigate("/app/dashboard", { replace: true });
                })
                .catch((error) => {  
                  setStatus("Invalid password or email.")
                }); 
            }} >
            {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values, status, }) => (
              <form onSubmit={handleSubmit}>
                <Box my={2} align="center">
                  <img alt="login" src={LoginImage} height="300" />
                </Box>
                {status ? (
                  <Box my={2} align="center">
                    <Alert severity="error">
                      <AlertTitle>Error</AlertTitle>
                      {status}
                    </Alert>
                  </Box>
                ) : null}

                <TextField error={Boolean(touched.email && errors.email)} fullWidth helperText={touched.email && errors.email} 
                  label="Email Address" margin="normal" name="email" onBlur={handleBlur} onChange={handleChange} 
                  type="email" value={values.email} variant="outlined" />

                <TextField error={Boolean(touched.password && errors.password)} fullWidth helperText={touched.password && errors.password}
                  label="Password" margin="normal" name="password" onBlur={handleBlur} onChange={handleChange}
                  type="password" value={values.password} variant="outlined" />

                <Box my={2} align="center">
                  {!isSubmitting ? (
                    <Button color="primary" disabled={isSubmitting} fullWidth size="large" type="submit" variant="contained" >
                      Sign in now
                    </Button>
                  ) : (
                    <Loader type="ThreeDots" color="blue" height={100} width={100} ></Loader>
                  )}
                </Box>
                <Typography color="textSecondary" variant="body1">{t('login.merhaba')}</Typography>
                <Typography>Admin Role : adminhasan@a.com</Typography>
                <Typography>Accountant Role : accountanthasan@a.com</Typography>
                <Typography>Client Role : clienthasan@a.com</Typography>
                <Typography>Worker Role : workerhasan@a.com</Typography>
                <Typography>One password for all: Abc123!!</Typography>
              </form>              
            )}
          </Formik>
        </Container>
      </Box>
    </Page>
  );
};

export default LoginView;
